import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FcpButtonModule } from 'fc-ui-components';

import { BackdropModule } from 'shared/components';
import { SignupErrorComponent } from './signup-error.component';

@NgModule({
    imports: [CommonModule, TranslateModule, FcpButtonModule, BackdropModule],
    declarations: [SignupErrorComponent],
    exports: [SignupErrorComponent]
})
export class SignupErrorModule {}
